import { selectMatchesByRecordSwiss } from "selectors/Match";
import { MatchesViewerMatch } from "../MatchesViewerMatch";
import { RecordContainer, RecordSet, SwissMatches } from "./styles";
import { useAppSelector } from "app/hooks";
import { PanelList } from "components/PanelList/PanelList";

interface Props {
  matchIds: string[];
  priorMatchIds: string[];
  tournamentId: string;
  hoverColor?: string;
}

export const SwissMatchesViewer = ({
  matchIds,
  priorMatchIds,
  tournamentId,
  hoverColor,
}: Props) => {
  const matchesByRecord = useAppSelector((state) =>
    selectMatchesByRecordSwiss(state, matchIds, priorMatchIds)
  );

  const sortedKeys = Array.from(matchesByRecord.keys()).sort(
    (a, b) => b.wins - a.wins
  );

  return (
    <div>
      {sortedKeys.map((k) => (
        <RecordSet>
          <SwissMatches>
            <PanelList hoverColor={hoverColor}>
              {matchesByRecord
                .get(k)!
                .sort((a, b) => a.startTimeMs - b.startTimeMs)
                .map((m) => (
                  <MatchesViewerMatch match={m} tournamentId={tournamentId} />
                ))}
            </PanelList>
          </SwissMatches>
          <RecordContainer>{`${k.wins} - ${k.loses}`}</RecordContainer>
        </RecordSet>
      ))}
    </div>
  );
};
